export const SIGNUP_PLAN_SELECTION_COMPLETED_AT_METADATA_KEY =
  "signupPlanSelectionCompletedAt";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function getIsSignupPlanSelectionCompleted(
  metadata: GraphQLJSON | null | undefined,
) {
  if (!isRecord(metadata)) return false;

  return (
    typeof metadata[SIGNUP_PLAN_SELECTION_COMPLETED_AT_METADATA_KEY] ===
    "string"
  );
}
